export default __webpack_public_path__ + "static/media/include_10@3x.b0cafe19.jpg";